import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AccountContext } from '@/services/api/accountTypes';

/**
 * Organization account session (internal realm) — kept apart from `authSlice`,
 * which holds the candidate/JMS session for the jobs portal.
 */
interface AccountAuthState {
  context: AccountContext | null;
  /** True until the initial localStorage rehydrate finishes. */
  loading: boolean;
}

const initialState: AccountAuthState = {
  context: null,
  loading: true,
};

const accountAuthSlice = createSlice({
  name: 'accountAuth',
  initialState,
  reducers: {
    setAccountContext: (state, action: PayloadAction<AccountContext>) => {
      state.context = action.payload;
      state.loading = false;
    },
    clearAccountContext: (state) => {
      state.context = null;
      state.loading = false;
    },
    accountRehydrated: (state) => {
      state.loading = false;
    },
  },
});

export const { setAccountContext, clearAccountContext, accountRehydrated } =
  accountAuthSlice.actions;

export default accountAuthSlice.reducer;
